import { render, staticRenderFns } from "./ContactMultiselect.vue?vue&type=template&id=98ca52ac&"
import script from "./ContactMultiselect.vue?vue&type=script&lang=js&"
export * from "./ContactMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports